import { Component, Input } from '@angular/core';


@Component({
  selector: 'ui-timeline-item',
  standalone: true,
  imports: [],
  templateUrl: './ui-timeline-item.component.html',
  styleUrl: './ui-timeline-item.component.scss'
})
export class UiTimelineItemComponent {
  /**
   * Position of the content box relative to the timeline
   * 'start' = left side, 'end' = right side
   */
  @Input() position: 'start' | 'end' = 'end';

  /**
   * Color variant for the icon and connector line
   */
  @Input() color: 'primary' | 'secondary' | 'accent' | 'success' | 'warning' | 'error' | 'info' | 'neutral' = 'primary';

  /**
   * Whether this is the first item (no line before)
   */
  @Input() isFirst = false;

  /**
   * Whether this is the last item (no line after)
   */
  @Input() isLast = false;

  get colorClass(): string {
    const colorMap: Record<string, string> = {
      primary: 'text-primary',
      secondary: 'text-secondary',
      accent: 'text-accent',
      success: 'text-success',
      warning: 'text-warning',
      error: 'text-error',
      info: 'text-info',
      neutral: 'text-neutral'
    };
    return colorMap[this.color] || 'text-primary';
  }

  get hrColorClass(): string {
    const colorMap: Record<string, string> = {
      primary: 'bg-primary',
      secondary: 'bg-secondary',
      accent: 'bg-accent',
      success: 'bg-success',
      warning: 'bg-warning',
      error: 'bg-error',
      info: 'bg-info',
      neutral: 'bg-neutral'
    };
    return colorMap[this.color] || 'bg-primary';
  }
}

